module.exports = __webpack_public_path__ + "img/social-icon-linkedin-white.6aafa3f4.svg";